<template>
<div class="s-layout" :style="colorObject">
  <div class="s-container">
    <Loading
      v-if="isLoading"
      loading-message="載入中..."
      :background-color="'#ffffff'"
    />

    <Header
      :meta="meta"
      :page-title="getModuleConfig('page_title')"
      :page-image="getModuleConfig('page_image')"
      :page-kv-image="getModuleConfig('page_kv_image')"
      :header-section="getModuleConfig('header_section')"
    />

    <div class="page">
      <div class="py-4 text-center">
        <img src="@/assets/images/icon-check-circle.svg" />
        <div class="mt-3 font-weight-bold" v-if="finishedPageTitle">{{ finishedPageTitle }}</div>
        <div class="mt-3 font-weight-bold" v-else>預約已成功送出</div>
        <div class="mt-3" v-html="deepGet(viewingBookingPreset, 'config.finished_page.content')"></div>
      </div>

      <div class="p-3 liff-reservation-form">
        <div
          v-for="(page, index) in visiblePages"
          :key="index"
        >
          <b-form-group
            :label="subject.title"
            label-cols="12"
            label-cols-sm="6"
            label-size="sm"
            label-for="input-sm"
            class="mb-3"
            v-for="(subject, i) in subjectsOfCurrentPageWithoutSection(page._id)"
            :key="i"
          >
            <div v-if="subject.type === 'uploader'">
              <a class="app-file-uploader__current-url text-right" :href="getFieldValue(subject)" target="_blank">
                <template v-if="getFieldValue(subject)">
                  <small>（查看檔案）</small>
                </template>
              </a>
            </div>
            <div v-else class="liff-reservation-form__field-value text-right">{{ getFieldValue(subject) }}</div>
          </b-form-group>

          <template v-for="(section, i) in sectionsOfCurrentPage(page._id)">
            <b-card
              header-tag="header"
              class="mb-3 liff-reservation-form__card"
              :key="`section${i}`"
              v-if="subjectsOfCurrentSection(section).length > 0"
            >
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">{{ section.title }}</h6>
                </div>
              </template>

              <b-form-group
                :label="subject.title"
                label-cols="12"
                label-cols-sm="6"
                label-size="sm"
                label-for="input-sm"
                class="mb-3"
                v-for="(subject, i) in subjectsOfCurrentSection(section)"
                :key="i"
              >
                <div v-if="subject.type === 'uploader'">
                  <a class="app-file-uploader__current-url text-right" :href="getFieldValue(subject)" target="_blank">
                    <template v-if="getFieldValue(subject)">
                      <small>（查看檔案）</small>
                    </template>
                  </a>
                </div>
                <div v-else class="liff-reservation-form__field-value text-right">{{ getFieldValue(subject) }}</div>
              </b-form-group>
            </b-card>
          </template>
        </div>
        <img :src="deepGet(viewingBookingPreset, 'config.finished_page.banner_image')" class="mt-3" style="width: 100%" />
      </div>

      <div class="footer-action-bar">
        <ShareButton
          v-if="showNextBookingButton"
          variant="s-btn-outline-primary"
          @click="handleNextBooking"
        >
          繼續預約
        </ShareButton>
        <ShareButton
          v-if="showGoBookingListButton"
          variant="s-btn-outline-primary"
          @click="$router.push({ name: 'LiffBookingPreset', params: { presetId: bookingPresetId } })"
        >
          預約紀錄
        </ShareButton>
        <MemberButton
          button-text="回 LINE 官方帳號"
          type="OA"
        >
        </MemberButton>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import bookingApi from '@/apis/liff/v2/booking'; // NOTE: only enable this when debugging
// import bookingPresetApi from '@/apis/liff/v2/booking-preset'; // NOTE: only enable this when debugging
import ShareButton from "@/components/Page/Liff/Shared/Button";
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import Loading from "@/components/Page/Liff/Shared/Loading";
import { themeColorFn } from "@/mixins/liff/themeColor";
import isEmpty from "@/utils/isEmpty";
import BookingPresetDataModel from "@/models/BookingPreset.model"
import DynamicFormField from '@/models/DynamicFormField.model'
import Datetime from '@/utils/value-objects/Datetime'
import { generateModuleConfigGetter } from "@/utils/liff/vueStoreHelpers";
import _ from "lodash";
import deepGet from "lodash/get";
import moment from "moment";
import { mapActions, mapGetters, mapState } from 'vuex';
import liff from "@line/liff";

export default {
  components: {
    ShareButton,
    MemberButton,
    Loading,
  },
  mixins: [
    themeColorFn({ themeConfigPage: 'booking' })
  ],
  data: () => ({
    isLoading: true,
  }),
  computed: {
    ...mapGetters({
        meta: "liffGeneral/meta",
        liffId: "liffGeneral/liffId",
        user: "liffAuth/user",
    }),
    ...mapState('liffBooking', ['submittedBooking', 'viewingBookingPreset']),
    bookingPresetId() {
      return this.$route.params.bookingPresetId
    },
    dataModel() {
      return new BookingPresetDataModel(this.viewingBookingPreset)
    },
    // bookingId() {
    //   return 'lq389prn2wxy' // NOTE: only enable this when debugging
    // },
    bookingData() {
      return _.chain(this.submittedBooking).get('data').keyBy('field_id').mapValues('value').value()
    },
    startTimeFieldConbinedWithBranchConfig() {
      const startAtDefaultField = this.dataModel.baseStartTimeField
      const startAtField = this.dataModel.branchStartTimeField || startAtDefaultField
      if (!startAtField || !startAtDefaultField) {
        return null
      }
      return {
        ...startAtField,
        id: startAtField._id,
        format: startAtDefaultField.format,
        date_condition: startAtDefaultField.date_condition,
        time_condition: startAtDefaultField.time_condition,
        time_style: startAtField.time_style == 'default' ? startAtDefaultField.time_style : startAtField.time_style,
        date_style: startAtField.date_style == 'default' ? startAtDefaultField.date_style : startAtField.date_style,
        options: _.get(startAtField, 'options', []).map(option => ({
          text: option.text,
          value: option.value || option.text,
        })),
        time_options: _.get(startAtField, 'time_options', []).map(option => ({
          text: option.text,
          value: option.value || option.text,
        })),
      }
    },
    subjects() {
      return DynamicFormField.fromArray(deepGet(this.viewingBookingPreset, 'config.fields', [])).map(fieldModel => {
        if (fieldModel._id === _.get(this.startTimeFieldConbinedWithBranchConfig, 'id')) {
          return this.startTimeFieldConbinedWithBranchConfig
        }
        return {
          ...fieldModel.flattenedAttributes(),
          id: fieldModel._id,
        }
      })
    },
    sections() {
      return deepGet(this.viewingBookingPreset, 'config.sections', [])
    },
    pages() {
      return deepGet(this.viewingBookingPreset, 'config.pages', [])
    },
    hasDefaultPage() {
      const visible = subjectOrSection => isEmpty(subjectOrSection.page_id) && this.passesVisibleCondition(subjectOrSection);
      return this.subjects.filter(visible).filter(subject => false === deepGet(subject, 'dashboard_only', false)).length > 0
        || this.sections.filter(visible).length > 0
        || false === this.hasSetUpFieldMappingForStartAt
        || false === this.hasSetUpFieldMappingForEndAt;
    },
    visiblePages() {
      const pagesFromConfig = _.sortBy(this.pages.filter(this.passesVisibleCondition), 'order');
      return this.hasDefaultPage ? [{ _id: null, title: null, order: 0 }, ...pagesFromConfig] : pagesFromConfig;
    },
    hasSetUpFieldMappingForStartAt() {
      return this.dataModel.hasSetUpFieldMappingForStartAt
    },
    hasSetUpFieldMappingForEndAt() {
      return this.dataModel.hasSetUpFieldMappingForEndAt
    },
    showNextBookingButton() {
      return deepGet(this.viewingBookingPreset, 'config.finished_page.enabled_next_booking_button', true);
    },
    showGoBookingListButton() {
      return deepGet(this.viewingBookingPreset, 'config.finished_page.enabled_go_booking_list_button', true);
    },
    finishedPageTitle() {
      return deepGet(this.viewingBookingPreset, 'config.finished_page.title', '');
    },
  },
  async mounted() {
    // this.setViewingBookingPreset(await bookingPresetApi.get(this.bookingPresetId)) // NOTE: only enable this when debugging
    // this.setSubmittedBooking(await bookingApi.getDetail({ id: this.bookingId })) // NOTE: only enable this when debugging
    this.isLoading = false
    await this.sendLiffMessage();
  },
  methods: {
    ...mapActions('liffBooking', ['setSubmittedBooking', 'setViewingBookingPreset']),
    deepGet,
    getModuleConfig: generateModuleConfigGetter('liff_booking'),
    handleNextBooking() {
      // 清除 Vuex Store 中的舊資料，避免新預約時出現上一次的資料
      this.setSubmittedBooking(null)
      this.setViewingBookingPreset(null)
      this.$router.push({ name: 'LiffBookingForm', params: { bookingPresetId: this.bookingPresetId } })
    },
    passesVisibleCondition(subjectOrSectionOrPage) {
      const anyConditions = deepGet(subjectOrSectionOrPage, 'visible_when_any', []);
      if (anyConditions.length === 0) {
        return true;
      }
      return anyConditions.some(condition => this.subjects.some(possibleSubject => {
        return condition.field_id === possibleSubject.id
          && condition.value === this.bookingData[possibleSubject.id];
      }));
    },
    subjectsOfCurrentSection(section) {
      return this.subjects.filter(subject => {
        return subject.section_id === section._id
          && this.passesVisibleCondition(subject)
          && false === deepGet(subject, 'dashboard_only', false)
      });
    },
    subjectsOfCurrentPageWithoutSection(pageId) {
      return this.subjects.filter(subject => {
        return isEmpty(subject.section_id)
          && (isEmpty(pageId) ? isEmpty(subject.page_id) : subject.page_id === pageId)
          && this.passesVisibleCondition(subject)
          && false === deepGet(subject, 'dashboard_only', false)
      });
    },
    sectionsOfCurrentPage(pageId) {
      return this.sections.filter(section => {
        return (isEmpty(pageId) ? isEmpty(section.page_id) : section.page_id === pageId)
          && this.passesVisibleCondition(section)
      });
    },
    getFieldValue(subject) {
      const fieldId = deepGet(subject, 'id')
      const value = deepGet(this.bookingData, fieldId, null)
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          if (typeof value[0] === 'object') {
            return deepGet(value[0], 'text', '')
          } else {
            return value.join(', ')
          }
        }
        return deepGet(value, 'text', '')
      } else {
        if (subject.type !== 'datetime') {
          return value
        }

        if (subject.format === 'datetime') {
          return this.formatDateTimeFieldWithAliases(subject, value)
        }

        if (subject.format === 'time') {
          return this.formatTimeFieldWithAlias(subject, value)
        }

        if (subject.format === 'date') {
          return this.formatDateFieldWithAlias(subject, value)
        }

        return value
      }
    },
    normalizeTimeKey(t) {
      if (t == null || t === '') return ''
      const parts = String(t).split(':')
      if (parts.length < 2) return String(t)
      const h = parts[0].padStart(2, '0')
      const m = parts[1].padStart(2, '0')
      return `${h}:${m}`
    },
    findDateOptionByValue(options, dateValue) {
      if (!Array.isArray(options) || !dateValue) return null
      const key = moment(dateValue).format('YYYY-MM-DD')
      if (!moment(dateValue).isValid()) return null
      return options.find((o) => {
        const candidateValue = o && (o.value || o.text)
        if (!candidateValue) return false
        return moment(candidateValue).format('YYYY-MM-DD') === key
      }) || null
    },
    findTimeOptionByValue(timeOptions, timeValue) {
      if (!Array.isArray(timeOptions) || timeValue == null || timeValue === '') return null
      const key = this.normalizeTimeKey(timeValue)
      return timeOptions.find((o) => o && this.normalizeTimeKey(o.value || o.text) === key) || null
    },
    formatDateFieldWithAlias(subject, rawValue) {
      if (!rawValue) return ''
      if (subject.date_condition !== 'limited' || !Array.isArray(subject.options)) {
        return rawValue
      }
      const opt = this.findDateOptionByValue(subject.options, rawValue)
      const alias = opt && opt.text != null ? String(opt.text).trim() : ''
      if (alias !== '') return alias
      return moment(rawValue).isValid() ? moment(rawValue).format('YYYY-MM-DD') : rawValue
    },
    formatTimeFieldWithAlias(subject, rawValue) {
      if (!rawValue) return ''
      if (subject.time_condition !== 'specified' || !Array.isArray(subject.time_options)) {
        return (new Datetime()).fromTime(rawValue).toTimeNoSecond()
      }
      const opt = this.findTimeOptionByValue(subject.time_options, rawValue)
      const alias = opt && opt.text != null ? String(opt.text).trim() : ''
      if (alias !== '') return alias
      return (new Datetime()).fromTime(rawValue).toTimeNoSecond()
    },
    formatDateTimeFieldWithAliases(subject, rawValue) {
      if (!rawValue || typeof rawValue !== 'string') {
        return rawValue
      }
      const dt = new Datetime().fromDatetime(rawValue)
      const datePart = dt.date
      const timePart = dt.time

      let dateLabel
      if (subject.date_condition === 'limited' && Array.isArray(subject.options)) {
        const dOpt = this.findDateOptionByValue(subject.options, datePart)
        const dAlias = dOpt && dOpt.text != null ? String(dOpt.text).trim() : ''
        dateLabel = dAlias !== '' ? dAlias : (moment(datePart).isValid() ? moment(datePart).format('YYYY-MM-DD') : datePart)
      } else {
        dateLabel = moment(datePart).isValid() ? moment(datePart).format('YYYY-MM-DD') : datePart
      }

      let timeLabel
      if (subject.time_condition === 'specified' && Array.isArray(subject.time_options)) {
        const tOpt = this.findTimeOptionByValue(subject.time_options, timePart)
        const tAlias = tOpt && tOpt.text != null ? String(tOpt.text).trim() : ''
        timeLabel = tAlias !== '' ? tAlias : (new Datetime()).fromTime(timePart).toTimeNoSecond()
      } else {
        timeLabel = (new Datetime()).fromTime(timePart).toTimeNoSecond()
      }

      return `${dateLabel} ${timeLabel}`.trim()
    },
    async sendLiffMessage() {

      const sendMessages = deepGet(this.viewingBookingPreset, 'config.finished_page.send_messages', null)

      if (sendMessages?.enabled && sendMessages?.text) {

        const messageText = sendMessages.text
        const submittedBooking = this.submittedBooking

         // 處理 {{$booking['x']}} - 加入 \s* 允許括號周圍有空格或無空格
         let result = messageText.replace(/\{\{\$booking\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return submittedBooking[key] || ""; });
        // 處理 {{$booking_data['field_id']}}
        result = result.replace(/\{\{\$booking_data\s*\['(.+?)'\]\s*\}\}/g, (_, fieldId) => {
          const field = submittedBooking.data.find(d => d.field_id === fieldId);
          if (!field) return "";

          if (typeof field.value === 'string') {
            return field.value;
          }

          if (Array.isArray(field.value)) {
              return field.value.map(v => v.text || "").join(", ");
            }

          if (typeof field.value === 'object' && field.value) {
            return field.value.text || "";
          }

          return "";
        });

         // 處理 {{$customer['extra']['x']}} 
         result = result.replace(/\{\{\$customer\s*\['extra'\]\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return this.user.extra[key] || ""; });
        
        // 處理 {{$customer['x']}} 
        result = result.replace(/\{\{\$customer\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return this.user[key] || ""; });


        console.log(result);

        await liff
          .sendMessages([
            {
              type: "text",
              text: result,
            },
          ])
          .then(() => {
            console.log("message sent");
          })
          .catch((err) => {
            console.log("error", err);
          });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/liff/main.css";
@import "../../../assets/css/liff/liff_init_theme_config.css";

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
  --s-danger: #fe0000;
}

.s-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  background: var(--liff-content_bg_color);
}

.liff-reservation-form {
  width: 100%;

  &__card {
    border-radius: 10px;
    border: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    .card-header {
      border-radius: 10px 10px 0 0;
      border-bottom: 1px solid #e5e5ea;
      font-size: 16px;
      font-weight: 500;
      padding: 16px 16px 12px 16px;
    }
  }

  &__field-value {
    min-height: 1.5rem;
    border-bottom: 1px solid #e5e5ea;
    line-height: 1.5rem;
    font-size: 0.875rem;
  }
}

.footer-action-bar {
  width: 100%;

  button {
    width: 100%;
  }

  button + button {
    margin-top: 16px;
  }
}

app-file-uploader__current-url {
  display: block;
  font-size: 0.875rem;
  color: #007bff;

  app-file-uploader:hover {
    text-decoration: underline;
    color: #007bff;
  }
}
</style>
